module.exports = __webpack_public_path__ + "img/app3.8f725937.png";